import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'practice',
    lazy: async () => ({ Component: (await import('./PracticePage')).PracticePage }),
  },
];
